import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import TicketEntryBlurb from './TicketEntryBlurb';
import TicketSamples from './TicketSamples';
import UserLockout from '../../utils/user_lockout';
import EnterTicketTabs from './EnterTicketTabs';

const EnterTicketsPage = () => {
    return (
        <UserLockout>
            <div className='enter-container container'>
                <div className='row justify-content-center'>
                    <div className='entry-box col-12 col-lg-6'>
                        <EnterTicketTabs />
                    </div>
                    <div className='entry-box col-12 col-lg-6'>
                        <TicketEntryBlurb />
                    </div>
                </div>
                <TicketSamples />
            </div>
        </UserLockout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterTicketsPage);
